<template>
  <div class="container" >
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th></th>
            <th>{{ $t('marketplace.order_detail.platform_order_id') }}</th>
            <th>{{ $t('marketplace.order_detail.order_item_id') }}</th>
            <th>{{ $t('marketplace.order_detail.title') }}</th>
            <th>{{ $t('marketplace.order_detail.quantity_ordered') }}</th>
            <th>{{ $t('marketplace.order_detail.imei_code') }}</th>
            <th>{{ $t('marketplace.order_detail.item_price') }}</th>
            <th>{{ $t('marketplace.order_detail.total_commission') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in orderItems" :key="index">
            <td>
              <b-form-checkbox :value="item.id" v-model="selectedId"></b-form-checkbox>
            </td>
            <td>{{ item.platform_order_id }}</td>
            <td>{{ item.order_item_id }}</td>
            <td>{{ item.title }}</td>
            <td>{{ item.quantity_ordered }}</td>
            <td>{{ item.imei_code }}</td>
            <td>{{ item.item_price }}</td>
            <td>{{ item.total_commission }}</td>
          </tr>
        </tbody>
      </table>
      <div slot="footer">
        <b-button type="submit" size="sm" variant="primary" @click.stop.prevent="handleSubmit"><i class="fa fa-dot-circle-o"></i> {{ $t('marketplace.rma_product.add_to_rma_product') }}</b-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'OrderItemList',
  props: {
    orderItems: {
      type: Array
    },
    addRmaProduct: {
      type: Function
    },
    selectedId: {
      type: Number || null
    }
  },
  methods: {
    handleSubmit () {
      // create store
     if (this.selectedId) {
        var vm = this
        var item = this.orderItems.find((item) => item.id === vm.selectedId)
        this.addRmaProduct(item)
     } else {
      this.$swal({
        title: 'Please select one item to add RMA product',
        icon: 'warning'
      })
     }
    },
  }
}
</script>
